import React, { memo } from 'react';

import { TVideoObjectFit } from '@src/types';

import styles from '../videoBox.module.scss';

interface VideoDisplayProps {
  videoRef: React.RefObject<HTMLVideoElement>;
  isMirrorActive: boolean;
  muted: boolean;
  poster?: string;
  objectFit?: TVideoObjectFit;
  id: string;
}

const VideoDisplay: React.FC<VideoDisplayProps> = ({ videoRef, isMirrorActive, muted, poster, objectFit, id }) => (
  <video
    id={id}
    className={isMirrorActive ? styles.mirror : ''}
    playsInline
    autoPlay
    muted={muted}
    poster={poster}
    ref={videoRef}
    style={{ objectFit }}
  >
    <track kind="captions" src="" label="No captions" />
  </video>
);

export default memo(VideoDisplay);
